import { IconAdornment } from '../icon/svg';
import React, { useEffect } from 'react';
import {
  useSlateStatic,
  ReactEditor,
} from 'slate-react';

import application from 'application';

import Helpers from '../../helpers';

import nodeControls from '../../node-menu/control-types';
import BaseElement from '../base';
import InlineChromiumBugfix from '../link/inline-chromium-bug-fix';
import ButtonOptionsForm from '../button/button-options-form';

import {
  addStyleBlock,
  updateStyleBlock,
  deleteStyleBlock
} from './utilities';

import { ReactComponent as EditIcon } from 'assets/images/edit-icon.svg';

import './index.scss';

function AuthenticatorButton(props) {

  const element = props.element;
  const attributes = props.attributes;
  const children = props.children;

  const editor = useSlateStatic();
  const elementPath = ReactEditor.findPath(editor, element);

  useEffect(function onLoad() {

    application.dynamicModulesManager.load('ace');

  }, []);

  useEffect(function onLoad() {

    addStyleBlock(element);

    return function onUnload() {
      deleteStyleBlock(element);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(function onElementChange() {

    return updateStyleBlock(element);

  }, [element]);

  async function showButtonOptions() {

    const result = await application.dialogsManager.displayWithHeader(ButtonOptionsForm, {
      title: 'Button options',
      contentConfiguration: {
        page: props.parentEntity,
        data: element,
        handleBuilder(path) {
          return `
function successHandler(page, button, authData, supportingData) {
  window.location.href = '${path}';
}`;

        }
      }
    });

    if (result.cancelled === true) {
      return;
    }

    const value = result.value;

    Helpers.setAttributes(editor, {
      ...element,
      options: {
        ...value.options
      }
    }, elementPath);

  }

  function renderEditButton() {

    const buttonAttribtues = {
      type: 'button',
      className: 'button-options-edit-button',
      onClick: showButtonOptions
    };

    return <button {...buttonAttribtues}><EditIcon /></button>;

  }

  function renderAuthenticatorButton() {

    const buttonOptions = element;

    const buttonBlockAttributes = {
      id: element.options?.id,
      className: 'authenticator-button button-block-container '
    };

    const linkAuthenticatorButtonControlAttributes = {
      ...attributes,
      className: 'link-button-control',
      href: buttonOptions.url,
      target: '_blank'
    };

    return <div {...buttonBlockAttributes}>

      <a {...linkAuthenticatorButtonControlAttributes}>
        <InlineChromiumBugfix />
        <IconAdornment element={element} position="start" />
        {children}
        <IconAdornment element={element} position="end" />
        <InlineChromiumBugfix />
      </a>
      {renderEditButton()}
    </div>;

  }

  function renderMain() {

    const baseElementProperties = {
      ...props,
      customNodeControls: [
        nodeControls.URL_INPUT,
        nodeControls.HOVER_BACKGROUND_COLOR,
        nodeControls.HOVER_TEXT_COLOR,
        nodeControls.ICON_SETTINGS,
        nodeControls.ALIGNMENT
      ],
      className: 'button-container'
    };

    return <BaseElement {...baseElementProperties}>
      {renderAuthenticatorButton()}
    </BaseElement>;

  }

  return renderMain();

}

export default AuthenticatorButton;